//const URI =  'http://localhost:5000/';

//server droplet
//export const URI =  'http://142.93.21.161:5000/';
//server droplet
//export const URI = '/';

export const URI =
    window.location.hostname === 'localhost'
        ? 'http://localhost:5000/'
        : '/';

const API_URL = {
   
    'POST_ADMIN_LOGIN': URI + 'api/adminuser/login',
    'POST_ADMIN_CREATE': URI + 'api/adminuser/create',
    'GET_ADMIN_ALL': URI + 'api/adminuser/',
    'DELETE_ADMIN': URI + 'api/adminuser/',

    'ADMIN_MANAGE_BUSINESS_TYPE' : URI + 'api/business_type/adminall',
    'ADMIN_CREATE_BUSINESS_TYPE' : URI + 'api/business_type/create',
    'ADMIN_DELETE_BUSINESS_TYPE' : URI + 'api/business_type/delete/',
    'ADMIN_UPDATE_BUSINESS_TYPE' : URI + 'api/business_type/update/',

    'ADMIN_GET_SERVICES' : URI + 'api/business_type/getservices/',
    'ADMIN_CREATE_SERVICE' : URI + 'api/business_type/createservice',
    'ADMIN_DELETE_SERVICE' : URI + 'api/business_type/deleteservice/' ,
    'ADMIN_UPDATE_SERVICE' : URI + 'api/business_type/updateservice/' ,
    'ADMIN_GET_SERVICE' : URI + 'api/business_type/getservice/',

    /*'ADMIN_WAIVER_BUILDER_SAVE_ELIGIBILITY_ADULT' : URI + 'api/admin_waiver_builder/eligibility_questions_adult/save' ,
    'ADMIN_WAIVER_BUILDER_GET_ELIGIBILITY_ADULT' : URI + 'api/admin_waiver_builder/eligibility_questions_adult/get' ,

    'ADMIN_WAIVER_BUILDER_SAVE_ELIGIBILITY_MINOR' : URI + 'api/admin_waiver_builder/eligibility_questions_minor/save' ,
    'ADMIN_WAIVER_BUILDER_GET_ELIGIBILITY_MINOR' : URI + 'api/admin_waiver_builder/eligibility_questions_minor/get' ,
    'ADMIN_WAIVER_BUILDER_DUPLICATE_ELIGIBILITY_FROM_ADULT' : URI + 'api/admin_waiver_builder/eligibility_questions_minor/duplicate-from-adult/',

    'ADMIN_WAIVER_BUILDER_SAVE_ELIGIBILITY_MINOR_QUICK' : URI + 'api/admin_waiver_builder/eligibility_questions_minor_quick/save' ,
    'ADMIN_WAIVER_BUILDER_GET_ELIGIBILITY_MINOR_QUICK' : URI + 'api/admin_waiver_builder/eligibility_questions_minor_quick/get' ,
    'ADMIN_WAIVER_BUILDER_DUPLICATE_ELIGIBILITY_FROM_ADULT_FOR_MINORQUICK' : URI + 'api/admin_waiver_builder/eligibility_questions_minor_quick/duplicate-from-adult/',


    'ADMIN_WAIVER_BUILDER_SAVE_ELIGIBILITY_ADULT_QUICK' : URI + 'api/admin_waiver_builder/eligibility_questions_adult_quick/save' ,
    'ADMIN_WAIVER_BUILDER_GET_ELIGIBILITY_ADULT_QUICK' : URI + 'api/admin_waiver_builder/eligibility_questions_adult_quick/get' ,
    'ADMIN_WAIVER_BUILDER_DUPLICATE_ELIGIBILITY_FROM_ADULT_FOR_ADULTQUICK' : URI + 'api/admin_waiver_builder/eligibility_questions_adult_quick/duplicate-from-adult/',
*/

    'ADMIN_WAIVER_BUILDER_SAVE_ELIGIBILITY_ALL' : URI + 'api/admin_waiver_builder/eligibility_questions_all/save' ,
    'ADMIN_WAIVER_BUILDER_GET_ELIGIBILITY_ALL': URI + 'api/admin_waiver_builder/eligibility_questions_all/get' ,
    
    
    'ADMIN_ADULT_FULL_WAIVER_SAVE' : URI + 'api/admin_waiver_builder/adult_full_waiver/save',
    'ADMIN_ADULT_FULL_WAIVER_GET' : URI + 'api/admin_waiver_builder/adult_full_waiver/get',

    'ADMIN_ADULT_QUICK_WAIVER_SAVE' : URI + 'api/admin_waiver_builder/adult_quick_waiver/save',
    'ADMIN_ADULT_QUICK_WAIVER_GET' : URI + 'api/admin_waiver_builder/adult_quick_waiver/get',

    'ADMIN_MINOR_FULL_WAIVER_SAVE' : URI + 'api/admin_waiver_builder/minor_full_waiver/save',
    'ADMIN_MINOR_FULL_WAIVER_GET' : URI + 'api/admin_waiver_builder/minor_full_waiver/get',

    'ADMIN_MINOR_QUICK_WAIVER_SAVE' : URI + 'api/admin_waiver_builder/minor_quick_waiver/save',
    'ADMIN_MINOR_QUICK_WAIVER_GET' : URI + 'api/admin_waiver_builder/minor_quick_waiver/get',

    'ADMIN_STATE_WAIVER_CLAUSES_SAVE' : URI + 'api/admin_waiver_builder/state_waiver_clauses/save',
    'ADMIN_STATE_WAIVER_CLAUSES_GET' : URI + 'api/admin_waiver_builder/state_waiver_clauses/get',
    'ADMIN_STATE_WAIVER_CLAUSES_DELETE' : URI + 'api/admin_waiver_builder/state_waiver_clauses/delete/',

    'ADMIN_GET_AUDIT_LOGS' : URI + 'api/audit_logs/admin_audit_logs/get/all',
    'ADMIN_GET_AUDIT_SESSIONS' : URI + 'api/audit_sessions/admin_audit_sessions/get/all',


    'BUSINESS_REGISTER' : URI + 'api/business/register',
    'BUSINESS_LOGIN' : URI + 'api/business/login',
    'BUSINESS_LOGOUT' : URI + 'api/business/logout',
    'BUSINESS_VERIFY_EMAIL' : URI + 'api/business/verify-email',
    'BUSINESS_EDIT_PROFILE' : URI + 'api/business/edit-profile/',
    'BUSINESS_GET_PROFILE' : URI + 'api/business/get-profile/',
    'GET_BUSINESS_BY_SLUG' : URI + 'api/business/getbusinessbyslug/',
    'BUSINESS_SERVICES' : URI + 'api/business/services/',
    'GET_STATE_CLAUSES_BY_STATES': URI + 'api/business/state_list/get-clauses-by-states',
    

    //Business Locations
    'BUSINESS_LOCATIONS': URI + 'api/business_location/list',
    'BUSINESS_ADD_LOCATION': URI + 'api/business_location/create',
    'BUSINESS_STATE_LIST': URI + 'api/business/state_list/states',
    'BUSINESS_COUNTY_LIST': URI + "api/business/county_list/counties",
    'BUSINESS_UPDATE_LOCATION': URI + 'api/business_location/edit',
    //Make Business Location active or inactive
    'BUSINESS_LOCATION_MAKE_INACTIVE': URI + 'api/business_location/inactivate_location',
    'BUSINESS_LOCATION_MAKE_ACTIVE': URI + 'api/business_location/activate_location',
    
    //MANAGE WAIVER URLS
    'BUSINESS_WAIVERS_LIST' : URI + 'api/business_waiver_builder/waiver_master/waiver_list',
    'BUSINESS_WAIVER_DISABLE':  URI + 'api/business_waiver_builder/waiver_master/disable',
    
    //CREATE EDIT WAIVER URLS
    'BUSINESS_WAIVERS_EXISTS' : URI + 'api/business_waiver_builder/waiver_master/waiver_exists/',
    'BUSINESS_WAIVER_BY_ID':  URI + 'api/business_waiver_builder/waiver_master',
    
    //POST/PATCH SAVE URLS
    //Step 1
    'BUSINESS_WAIVER_SMART_STEP_SELECT_SERVICE':  URI + 'api/business_waiver_builder/waiver_master/smart_step_select_service',
    //Step 2 - old step 5
    'BUSINESS_WAIVER_SMART_STEP_SAVE_LOCATION': URI + 'api/business_waiver_builder/waiver_master/smart_step_waiver_locations',
    //Step 3 - old step 2
    'BUSINESS_WAIVER_SMART_STEP_MINOR_PERMISSION':  URI + 'api/business_waiver_builder/waiver_master/smart_step_minor_permissions',
    //Step 4 - old step 3
    'BUSINESS_WAIVER_SMART_STEP_RETURNING_POLICY': URI + 'api/business_waiver_builder/waiver_master/smart_step_returning_policy',
    //Step 5 - old step 4
    'BUSINESS_WAIVER_SMART_STEP_WAIVER_QUESTIONS': URI + 'api/business_waiver_builder/waiver_master/smart_step_waiver_questions',
    //Step 6 
    'BUSINESS_WAIVER_SMART_STEP_WAIVER_SECTIONS': URI + 'api/business_waiver_builder/waiver_master/smart_step_waiver_sections',
    'BUSINESS_WAIVER_COMPLETE_STEP_WAIVER_SECTIONS': URI + 'api/business_waiver_builder/waiver_master/smart_step_waiver_sections_mark_completed',
    'GET_STATE_CLAUSES_FOR_WAIVER': URI + 'api/business/state_list/get-clauses-for-business',
    
    //Step 7 
    'BUSINESS_WAIVER_PUBLISH':  URI + 'api/business_waiver_builder/waiver_master/publish',
    

    //Existing Locations for a business
    'EXISTING_LOCATIONS': URI + 'api/business_waiver_builder/waiver_master/existing-locations',
    //Waiver Forms and Questions
    'BUSINESS_ELIGIBILITY_BY_WAIVER':  URI + 'api/business_waiver_builder/waiver_master/eligibility',
    
    //Create new version for published waivers
    'BUSINESS_CREATE_NEW_VERSION': URI + 'api/business_waiver_builder/waiver_master/create_new_version',
    'BUSINESS_WAIVER_VERSION_HISTORY': URI + 'api/business_waiver_builder/waiver_master/version-history',
    'BUSINESS_DISCARD_NEW_VERSION': URI + "api/business_waiver_builder/waiver_master/discard-new-version",
    // NOT USED as FETCHED DURING FETCH WAIVER ITSELF: 'BUSINESS_WAIVER_CHANGES_IN_NEW_VERSION': URI + 'api/business_waiver_builder/waiver_master/change-summary',
    

    //Business waiver edit mode selected.
    'BUSINESS_WAIVER_ENTER_EDIT_MODE': URI + 'api/business_waiver_builder/waiver_master/update_wizard_mode_to_edit',
    //'BUSINESS_WAIVER_ENTER_CREATE_MODE': URI + 'api/business_waiver_builder/waiver_master/update_wizard_mode_to_create',

    'BUSINESS_WAIVER_ACCEPT_ELIGIBILITY_CHANGES': URI + 'api/business_waiver_builder/waiver_master/eligibility-changes-accepted',
    'BUSINESS_WAIVER_CHECK_ELIGIBILITY_CHANGES': URI + 'api/business_waiver_builder/waiver_master/check-eligibility-changes',
    'BUSINESS_GET_RECENT_ACTIVITY':  URI + "api/recent_activity/business/recent_activity",
    'MASTER_BUSINESS_TYPE' : URI + 'api/business_type/all',

    'BUSINESS_ACTIVE_WAIVER_COUNT': URI + "api/business_waiver_builder/waiver_master/active/count",
    'BUSINESS_LOCATION_QR_CODES':  URI + "api/sign_waiver/location_qr_codes", //not used currently instead uses BUSINESS_LOCATIONS and BUSINESS_WAIVERS_LIST, to get QR codes

    
    'CUSTOMER_START_WAIVER': URI + 'api/sign_waiver/start_waiver',
    'CUSTOMER_RESEND_OTP': URI + 'api/sign_waiver/resend_otp',
    'BUSINESS_WAIVER_SIGNATURES':  URI + 'api/sign_waiver/waivers/signatures',
    'BUSINESS_WAIVER_SIGNATURE_COUNT':  URI + "api/sign_waiver/waivers/signatures/count",
    'BUSINESS_PDF_DOWNLOAD': URI + 'api/pdf_documents/download',
    'BUSINESS_PDF_VIEW': URI + 'api/pdf_documents/view',


    'CUSTOMER_CHECK_RECORD' : URI + 'api/customer/check_record',
    'CUSTOMER_VERIFY_OTP' : URI + 'api/customer/verify_otp',
    'CUSTOMER_SAVE_DOB' : URI + 'api/customer/save_dob/',
    'CUSTOMER_VERIFY_GUARDIAN_OTP' : URI + 'api/customer/verify_guardian_otp/',
    'CUSTOMER_GET_PROFILE' : URI + 'api/customer/get_profile/',
    'CUSTOMER_EDIT_PROFILE' : URI + 'api/customer/edit_profile/',
    'CUSTOMER_REQUEST_PHONE_CHANGE' : URI + 'api/customer/request_phone_change/',
    'CUSTOMER_VERIFY_NEW_PHONE_OTP': URI + 'api/customer/verify_new_phone_otp/',


    //pdf related routes
    'CUSTOMER_GENERATE_SIGNED_PDF_FILE': URI + 'api/pdf_documents/generate',
    'CUSTOMER_LOGIN': URI + 'api/customer/login',




}

Object.freeze(API_URL);

export default API_URL;
